import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getCookie } from "@/services/Auth/loginService";
import { getUserRole } from "@/services/Auth/loginService";

const PrivateRoute = ({ allowedRoles }) => {
  // Obtener el token y el rol del usuario
  const token = getCookie("token");
  const role = getUserRole(); // Asumimos que getUserRole retorna el rol del usuario

  
  // Si no hay token (usuario no autenticado), redirigir al login
  if (!token) {
    return <Navigate to="/login" />;
  }

  // Si el usuario no tiene el rol permitido, redirigir al dashboard correspondiente o a una página predeterminada
  if (!allowedRoles.includes(role?.toLowerCase())) {
    switch (role?.toLowerCase()) {
      // case "client":
      //   return <Navigate to="/dashboard/client" />;
      case "client":
      case "lawyer":
      case "abogado":
        return <Navigate to="/dashboard/lawyer" />;
      case "admin":
        return <Navigate to="/dashboard/admin" />;
      default:
        return <Navigate to="/" />;  // Si el rol no coincide, redirige al inicio
    }
  }

  // Si está autenticado y tiene el rol permitido, permite el acceso a las rutas hijas
  return <Outlet />;
};

export { PrivateRoute };
